import template from './carousel.template.html';
import controller from './carousel.controller';
import './carousel.scss';

const carouselComponent = {
  template,
  controller,
  bindings: {
    carouselSettings: '<',
    carouselWatch: '<',
    carouselName: '@',
  },
  transclude: true,
};

export default carouselComponent;



// WEBPACK FOOTER //
// ./src/app/shared/carousel/carousel.component.js